module.exports = __webpack_public_path__ + "img/movistar-arena.b3db8c0e.jpg";